import { CANCEL_PHOTO_REPOSITION, START_PHOTO_REPOSITION } from './actionTypes';
export var startPhotoReposition = function () { return function (dispatch) {
    dispatch({ type: START_PHOTO_REPOSITION });
}; };
export var cancelPhotoReposition = function () { return function (dispatch) {
    dispatch({ type: CANCEL_PHOTO_REPOSITION });
}; };
